import Model from '../../ModelBinding/Model';
import MissionQcRateColletion from './MissionQcRateCollection';
import MissionGivenGradesColletion from '../MissionGivenGrades/MissionGivenGradesCollection';
import dayjs from 'dayjs';

export default class MissionQcRate extends Model {
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;
  public given_grades?: MissionQcRateColletion;
  public rate_grade?: Number;

  bind() {
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');  
    this.given_grades = this.getRelationCollection('given_grades', MissionGivenGradesColletion);
    this.rate_grade = this.getFloatAttribute('rate_grade'); 
  }

  static getCollection() {
    return MissionQcRateColletion;
  }
}
